import { FormVmItemConfigType, FormVmValueType, FormVmValueValidatorResultType, InitialData } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';
import { trimSpaces } from '../../../../../../modules/formatters';
import { plainText, url } from '../../../../../../modules/validators';
import { REDIRECTION_URL_TEXT } from './url-redirection-form.texts';

export enum UrlRedirectionFieldKey {
    ENABLED = 'urlRedirectionEnabled',
    URL = 'redirectUrl',
}

const requiredWhenEnabledValidator = (value: FormVmValueType, values: InitialData = {}): FormVmValueValidatorResultType =>
    values[UrlRedirectionFieldKey.ENABLED] ? plainText.required(value as string) : { valid: true, validationMessage: null };

export const URL_REDIRECTION_FORM_CONFIG = {
    [UrlRedirectionFieldKey.ENABLED]: {
        defaultValue: false,
    },
    [UrlRedirectionFieldKey.URL]: {
        labelDescriptor: REDIRECTION_URL_TEXT,
        defaultValue: '',
        validators: [requiredWhenEnabledValidator, plainText.maxLength.medium, url.regExp],
        formatters: [trimSpaces],
    },
};

export const urlRedirectionConfigList: FormVmItemConfigType[] = buildConfigList(URL_REDIRECTION_FORM_CONFIG);
